module.exports = __webpack_public_path__ + "static/media/med.8204bcdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/cat/med.png
// module id = 111
// module chunks = 0